import { createContext, useContext } from 'react';

// Whether the user has spent their AI allowance (#208), and the reason the backend gave for
// refusing. Seeded from the profile on load (UserProfileDto.aiCapped) so a reload does not
// forget, and flipped by the app-wide 'ai:capped' announcement authedFetch raises on a 402.
//
// Consumed by the screens that spend money, so they can disable those actions and say why
// instead of offering a button that is certain to fail. Reading a chat, a discussion or a
// persona costs nothing and stays available.
export const SpendingCapContext = createContext({ capped: false, cappedMessage: '' });

export function useSpendingCap() {
  return useContext(SpendingCapContext);
}
